import React from "react";
import { TContainerStateProps } from "../../state/TContainerStateProps";
import { CRMPageWrap } from "../../components/Simple/CRMPageWrap/CRMPageWrap";
import { CRMPageBody } from "../../components/Simple/CRMPageBody/CRMPageBody";
import { CRMHomesMenuBarContainer } from "../../containers/CRMHomesMenuBarContainer/CRMHomesMenuBarContainer";
import { Padding } from "../../components/BuildingBlocks/Padding";
import { SpacingColumn } from "../../components/BuildingBlocks/SpacingColumn";
import { Text } from "../../components/BuildingBlocks/Text";
import { WeightBold } from "../../components/WeightBold/WeightBold";
import { CRMSpacing } from "../../models/CRMSpacing";
import { CRMColors } from "../../models/CRMColors";
import { CRMListingsProfitReportTable } from "../../components/CRMListingsProfitReportTable/CRMListingsProfitReportTable";

export const CRMListingsProfitReportPage = (props: TContainerStateProps): JSX.Element => {
    const report = props.state.forms.listings_profit_report_page.report;

    return (
        <CRMPageWrap>
            <CRMHomesMenuBarContainer {...props} />

            <CRMPageBody>
                <Padding spacing={CRMSpacing.LARGE}>
                    <SpacingColumn spacing={CRMSpacing.MEDIUM}>
                        <WeightBold><Text size={20}>Listings profit report</Text></WeightBold>

                        {report.status === "loading"
                            ? <Text color={CRMColors.NEUTRAL_4}>Loading…</Text>
                            : report.status === "failure"
                                ? <Text color={CRMColors.HIGHLIGHTS_INSTRUCTIONAL_BRICK_0}>
                                    Couldn't load the profit report — please refresh, and if it persists, flag it (the server logged the cause).
                                </Text>
                                : <CRMListingsProfitReportTable rows={report.output.rows} />
                        }
                    </SpacingColumn>
                </Padding>
            </CRMPageBody>
        </CRMPageWrap>
    );
};
